import useIsAppWebView from "@hooks/useIsAppWebView";
import ArticleContentAppWebView from "@routes/Article/ArticleContentAppWebView";
import { ArticlePageData } from "@routes/Article/utils/types";

import ArticlePageContent from "./ArticlePageContent";

const ArticleWrapper = (data: ArticlePageData): React.ReactElement => {
  const isWebView = useIsAppWebView();

  if (isWebView) return <ArticleContentAppWebView {...data} />;

  return <ArticlePageContent {...data} />;
};

export default ArticleWrapper;
